export function Deezer({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 277.7 277.7"
      fill="currentColor"
      className={className}
    >
      <title>Deezer</title>
      <path d="M232.9 42.4c2.6-14.9 6.3-24.3 10.5-24.3 7.8 0 14.1 32.5 14.1 72.6 0 40.1-6.3 72.6-14.1 72.6-3.2 0-6.1-5.5-8.5-14.8-3.8 33.8-11.5 57.1-20.6 57.1-7 0-13.2-14-17.4-36-2.9 41.9-10.1 71.7-18.5 71.7-5.3 0-10.1-11.8-13.7-31-4.3 39.6-14.2 67.4-25.8 67.4s-21.5-27.7-25.8-67.4c-3.5 19.2-8.4 31-13.7 31-8.4 0-15.6-29.7-18.5-71.7-4.2 22-10.4 36-17.4 36-9 0-16.8-23.3-20.6-57.1-2.4 9.3-5.3 14.8-8.5 14.8-7.8 0-14.1-32.5-14.1-72.6 0-40.1 6.3-72.6 14.1-72.6 4.2 0 7.9 9.4 10.5 24.3C49 16.7 55.7 0 63.4 0c9 0 16.9 23.6 20.6 57.9 3.6-25 9.2-40.9 15.3-40.9 8.7 0 16 31.3 18.8 74.9 5.1-22.4 12.6-36.4 20.8-36.4 8.2 0 15.6 14 20.8 36.4 2.7-43.6 10.1-74.9 18.8-74.9 6.2 0 11.7 15.9 15.3 40.8C197.4 23.6 205.3 0 214.3 0c7.6 0 14.4 16.7 18.6 42.4zM0 83.5C0 65.6 3.6 51 8 51s8 14.5 8 32.5c0 17.9-3.6 32.5-8 32.5s-8-14.5-8-32.5zm261.7 0c0-17.9 3.6-32.5 8-32.5s8 14.5 8 32.5c0 17.9-3.6 32.5-8 32.5-4.5 0-8-14.5-8-32.5z" />
    </svg>
  );
}
